import Vue from 'vue';

const scroller = () => {
	let el = document.getElementById('gallery');



	new Vue({
		el,
		data: {
			active: false,
		},
		computed: {
			animatingClass() {
				return this.active ? 'homepage-hero__gallery--active' : '';
			},
		},
		methods: {
			handleEnter() {

				let scroll = () => {
					setTimeout(() => {
						this.active = false;
					}, 10000)
				}

				if(this.active) {
					clearTimeout(scroll)
				} else {
					this.active = true;
					scroll();
				}

			},
		},
	});

}

export default scroller;


// WEBPACK FOOTER //
// ./scripts/modules/scroller.js